import React from 'react'

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-brand">
          <a className="logo" href="/">
            <div className="logo-img">
              <img src="images/logo.PNG" alt="Logo Agrosinal" />
            </div>
            <div>
              <div className="logo-name">AGROSINAL</div>
              <div className="logo-tagline">Tecnologia</div>
            </div>
          </a>

          <p>
            Laboratório especializado em tecnologia agrícola, oferecendo
            soluções completas em agricultura de precisão para produtores
            rurais.
          </p>

          <div className="social-links">
            <a
              href="https://instagram.com/jean.braghini"
              target="_blank"
              rel="noreferrer"
              className="icon"
            >
              <i className="bi bi-instagram"></i>
            </a>
            <a
              href="https://facebook.com/usuario"
              target="_blank"
              rel="noreferrer"
              className="icon"
            >
              <i className="bi bi-facebook"></i>
            </a>
            <a
              href="https://wa.me/5567981414278"
              target="_blank"
              rel="noreferrer"
              className="icon"
            >
              <i className="bi bi-whatsapp"></i>
            </a>
          </div>
        </div>

        <div className="footer-column">
          <h4>Serviços</h4>
          <ul>
            <li>
              <a href="#servicos">Antenas GPS</a>
            </li>
            <li>
              <a href="#servicos">Monitores</a>
            </li>
            <li>
              <a href="#servicos">Atualização</a>
            </li>
            <li>
              <a href="#servicos">Hardware</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Navegue</h4>
          <ul>
            <li>
              <a href="#sobre">Sobre Nós</a>
            </li>
            <li>
              <a href="#produtos">Produtos</a>
            </li>
            <li>
              <a href="#contato">Contato</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Contatos</h4>
          <ul>
            <li>
              <a href="https://wa.me/5567996827712">(67) 9 9682-7712</a>
            </li>
            <li>
              <a href="https://wa.me/5567981414278">(67) 9 8141-4278</a>
            </li>
            <li>Naviraí/MS</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          Copyright &copy; 2026 - Agrosinal Tecnologia. Todos os direitos
          reservados.
        </p>

        <a
          href="https://alinemayara.vercel.app"
          target="_blank"
          rel="noreferrer"
        >
          <span>
            Desenvolvido por Aline Mayara ❤️ <i class="fa-solid fa-mug-hot"></i>
          </span>
        </a>
      </div>
    </footer>
  )
}

export default Footer
